import { useContext, useEffect, useState } from 'react';
import { WelletContext } from '../../../context/WelletContext';
import ContentApp from '../../../components/ContentApp';
import AccountHeaderConsumer from '../../../components/HeaderConsumer/HeaderConsumer';
import CardEventsDetails from '../../../components/CardEventsDetails/CardEventsDetails';
import { CircleSpinner } from 'react-spinners-kit';
import EmptyActivity from '../../../components/Common/EmptyActivity/EmptyActivity';
import { useTranslation } from 'react-i18next';
import NavSelector from '../../../components/NavSelector/NavSelector';


const Etickets = ({ history }) => {
  const welletContext = useContext(WelletContext);
  const [eventsTickets, setEventsTickets] = useState([]);
  const [reservationType, setReservationType] = useState('after');
  const [loading, setLoading] = useState(false);
  const buttonTypes = ['after', 'before'];
  const { t } = useTranslation();

  const eventsHome = async (filterType) => {
    setLoading(true);
    try {
      const response = await welletContext.apis.tickets.post('/reservation/upcoming', {
        limit: 100,
        skip: 0,
        filterDate: filterType === 'after' ? 'UPCOMING' : 'PREVIOUS_RESERVATIONS',
      });
      setEventsTickets(response.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    eventsHome(reservationType);
  }, [reservationType]);

  const handleCategoryClick = (category) => {
    setReservationType(category);
  };

  return (
    <>
      <AccountHeaderConsumer />
      <ContentApp menu header>
        <div className='row text-center mt-3 px-3'>
          {buttonTypes.map((category) => (
            <div
              key={category}
              onClick={() => handleCategoryClick(category)}
              className='col p-2'
              style={{
                cursor: 'pointer',
                borderBottom:
                  reservationType === category
                    ? '4px solid var(--color-primary)'
                    : '1px solid #7E7E7E',
              }}
            >
              <div className='d-flex justify-content-center'>
                {category === 'after' ? (
                  <div className='text-center'>{t('upcomingEvents')}</div>
                ) : (
                  <div className='text-center'>{t('pastEvents')}</div>
                )}
              </div>
            </div>
          ))}
        </div>

        {loading ? (
          <div className='loaderDiv'>
            <CircleSpinner
              className='spinner-app mx-auto'
              style={{ margin: 'auto' }}
              size={40}
              color='var(--color-font-primary)'
            />
          </div>
        ) : eventsTickets.length > 0 ? (
          <div className='mt-3'>
            {reservationType === 'after'
              ? eventsTickets.map((event) => (
                  <CardEventsDetails
                    key={event.id}
                    eventSubName={
                      event.eventShow === null ? event.city?.name : event.restaurantName
                    }
                    reservationType={event.reservationType}
                    pax={event.pax}
                    bannerImage={event.eventShow?.bannerImage || event.restaurantBanner}
                    eventName={event.eventShow?.name || event.restaurantName}
                    startDate={event.eventShow?.startDate || event.reservationLocalTime}
                    onClick={() => {
                      history.push(`/ticket-details?ticketId=${event.id}`);
                    }}
                  />
                ))
              : eventsTickets.map((event) => (
                  <CardEventsDetails
                    ticketpass={true}
                    key={event.id}
                    eventSubName={
                      event.eventShow === null ? event.city?.name : event.restaurantName
                    }
                    reservationType={event.reservationType}
                    pax={event.pax}
                    bannerImage={event.eventShow?.bannerImage || event.restaurantBanner}
                    eventName={event.eventShow?.name || event.restaurantName}
                    startDate={event.eventShow?.startDate || event.reservationLocalTime}
                    onClick={null}
                  />
                ))}
          </div>
        ) : (
          <div className='mt-3'>
            <EmptyActivity icon={'notification'} title={t('thereAreNoEventsAvailable')} />
          </div>
        )}
        <NavSelector history={history} />
      </ContentApp>
    </>
  );
};

export default Etickets;
